<div class="card">
  <div class="card-body">
    @if (canNavigateToJobs) {
      <a [routerLink]="'/jobs'" class="card-title h5">
        <span class="material-symbols-outlined">schedule</span>
        <span style="vertical-align: middle" class="ms-2">{{ configuration.title || ('dashboard.dailyScanTimes.title' | translate) }}</span>
        <span class="badge rounded-pill text-bg-warning ms-2 beta-badge">
          {{ 'dashboard.badges.beta' | translate }}
        </span>
      </a>
    } @else {
      <div class="card-title h5">
        <span class="material-symbols-outlined">schedule</span>
        <span style="vertical-align: middle" class="ms-2">{{ configuration.title || ('dashboard.dailyScanTimes.title' | translate) }}</span>
        <span class="badge rounded-pill text-bg-warning ms-2 beta-badge">
          {{ 'dashboard.badges.beta' | translate }}
        </span>
      </div>
    }
    @if (configuration.description) {
      <h6 class="card-subtitle mb-2 mt-2 text-muted">{{ configuration.description }}</h6>
    }

    <app-loading-indicator [loading]="isLoading"></app-loading-indicator>

    @if (!isLoading) {
      <div class="daily-scan-times-widget">
        <div class="d-flex justify-content-end align-items-center mb-3">
          <div class="date-range text-muted small">
            <span class="material-symbols-outlined" style="font-size: 16px; vertical-align: middle;">calendar_today</span>
            @if (isCustomRange()) {
              <span class="ms-1">{{ getDateRangeDisplay() }}</span>
            } @else {
              <span class="ms-1">{{ 'dashboard.edit.JobDashboardComponent.rangeOptions.' + getRangeKey() | translate }}</span>
            }
          </div>
        </div>

        @if (error) {
          <div class="alert alert-danger py-2 mb-3">
            <span class="material-symbols-outlined me-2" style="font-size: 18px; vertical-align: middle;">error</span>
            {{ error }}
          </div>
        }

        @if (warnings.length > 0) {
          <div class="warnings mb-3">
            @for (warning of warnings; track warning) {
              <div class="alert alert-warning py-1 mb-1">{{ warning }}</div>
            }
          </div>
        }

        @if (!configuration.scanTimestampFieldKey) {
          <div class="no-data">
            {{ 'dashboard.dailyScanTimes.noFieldConfigured' | translate }}
          </div>
        } @else if (!hasScans()) {
          <div class="no-data">
            {{ 'dashboard.dailyScanTimes.noData' | translate }}
          </div>
        } @else {
          <div class="table-responsive">
            <table class="table table-hover table-sm">
              <thead>
                <tr>
                  <th>{{ 'dashboard.dailyScanTimes.date' | translate }}</th>
                  <th class="text-end">{{ 'dashboard.dailyScanTimes.firstScan' | translate }}</th>
                  <th class="text-end">{{ 'dashboard.dailyScanTimes.lastScan' | translate }}</th>
                  <th class="text-end">{{ 'dashboard.dailyScanTimes.scans' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (day of days; track day.date) {
                  <tr>
                    <td>{{ formatDate(day.date) }}</td>
                    <td class="text-end scan-time">{{ formatScanTime(day.firstScan) }}</td>
                    <td class="text-end scan-time">{{ formatScanTime(day.lastScan) }}</td>
                    <td class="text-end text-muted">{{ day.scanCount }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    }
  </div>
</div>
